import { View } from "@faire/retailer-visitor-shared/components/AppSignIn/components/View";
import {
  ILogExceptionOptions,
  logError,
} from "@faire/web--source/common/logging";

export const logErrorSignIn = (
  currentView: keyof typeof View,
  error?: string,
  options?: ILogExceptionOptions
) =>
  logError(
    error
      ? `${currentView} - ${error}`
      : `Error in SignInController for view: ${currentView}`,
    options
  );
